"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraVfxStepArgs = void 0;
const uuid_1 = require("uuid");
const CameraAction_1 = require("../CameraAction");
const SequenceBuilder_1 = require("../SequenceBuilder");
const TimeInterval_1 = require("../TimeInterval");
class CameraVfxStepArgs {
    constructor(action, duration) {
        this.action = action;
        this.duration = duration;
        this.__typeName = "Camera";
        this.id = (0, uuid_1.v4)();
    }
}
exports.CameraVfxStepArgs = CameraVfxStepArgs;
_a = CameraVfxStepArgs;
CameraVfxStepArgs.Effect = (effect, ms = 600) => new CameraVfxStepArgs(effect, new TimeInterval_1.MillisecondVfxTimeInterval(ms));
CameraVfxStepArgs.Zoom = (zoom, ms = 1000) => new CameraVfxStepArgs(new CameraAction_1.ZoomVfxCameraAction(zoom), new TimeInterval_1.MillisecondVfxTimeInterval(ms));
CameraVfxStepArgs.ZoomReset = (ms = 1000) => new CameraVfxStepArgs(CameraAction_1.ZoomVfxCameraAction.Default, new TimeInterval_1.MillisecondVfxTimeInterval(ms));
CameraVfxStepArgs.Rotate = (degrees, ms = 1200) => new CameraVfxStepArgs(new CameraAction_1.RotateVfxCameraAction(degrees), new TimeInterval_1.MillisecondVfxTimeInterval(ms));
CameraVfxStepArgs.RotateReset = (ms = 1200) => new CameraVfxStepArgs(CameraAction_1.RotateVfxCameraAction.Default, new TimeInterval_1.MillisecondVfxTimeInterval(ms));
CameraVfxStepArgs.Alpha = (alpha, ms = 1000) => new CameraVfxStepArgs(new CameraAction_1.AlphaVfxCameraAction(alpha), new TimeInterval_1.MillisecondVfxTimeInterval(ms));
CameraVfxStepArgs.AlphaReset = (ms = 1000) => new CameraVfxStepArgs(CameraAction_1.AlphaVfxCameraAction.Default, new TimeInterval_1.MillisecondVfxTimeInterval(ms));
CameraVfxStepArgs.mkSequencesFor = (...args) => {
    const applyCameraVfx = (0, SequenceBuilder_1.mkVfxSequenceBuilder)("parallel");
    const resetCameraVfx = (0, SequenceBuilder_1.mkVfxSequenceBuilder)("parallel");
    for (let arg of args) {
        applyCameraVfx.push(arg);
        switch (arg.action.__typeName) {
            case "Zoom":
                resetCameraVfx.push(_a.ZoomReset(arg.duration.milliseconds));
                break;
            case "Rotate":
                resetCameraVfx.push(_a.RotateReset(arg.duration.milliseconds));
                break;
            case "Alpha":
                resetCameraVfx.push(_a.AlphaReset(arg.duration.milliseconds));
                break;
            case "Effect":
                break;
        }
    }
    return { applyCameraVfx, resetCameraVfx };
};
